import { Button, Flex, Grid, Label, layout, P, Span, styled } from '@fareye/ui'
import {
  IoIosAirplane,
  MdDirectionsBoat,
  MdLocalShipping,
  MdTrain
} from '@fareye/utils'

export const LayoutFlex: any = styled(Flex)`
  ${(props: any) => {
    const { theme } = props
    return `
      background: ${theme.colors.gray2};
      `
  }}
`
export const BiGrid = styled(Grid)`
  padding-left: 10px;
  padding-right: 10x;
`
export const DetailsLabel = styled(Span)`
  width: 30%;
`
export const IssueRaisedButton = styled(Button)`
  ${(props: any) => {
    return `
      width: 90%;
      display: block;
      color: ${props.theme.colors.blue7};
      background: ${props.theme.colors.blue1};
      margin: 10px auto;
    `
  }}
`
export const CustomErrorSpan = styled(Span)`
  ${(props: any) => {
    return `
    font-size: 12px;
    color: ${props.theme.colors.red7};
    `
  }}
`
export const IssueLabelText = styled(Label)`
  ${(props: any) => {
    return `
    font-size: 14px;
    color: ${props.theme.colors.black};
    letter-spacing:1px;
    `
  }}
`
export const IssueContainerFlex: any = styled(Flex)`
  margin-top: 5px;
  justify-content: space-between;
  align-items: center;
`
export const IssueValueFlex: any = styled(Flex)`
  width: 65%;
  ${(props: any) => `
    .fe-ui__control:hover , .mention-input__control:hover{
      border: 1px solid #40a9ff !important;
    }
  `}
`
export const IssueHeadingText = styled(P)`
  font-size: 12px;
  margin-bottom: 10px;
  color: ${(props: any) => props.theme.colors.gray7};
`
export const FaUserCircleStyle = styled(Span)`
  font-size: 18px;
  color: ${(props: any) => props.theme.colors.blue9};
`
export const FaShareContainer = styled(Span)`
  font-size: 14px;
  margin-right: 10px;
  ${(props: any) => props.theme.colors.gray6}
`
export const FaBellContainer = styled(Span)`
  ${(props: any) => {
    return `
    font-size:14px;
    color:${props.theme.colors.gray6};
    margin-right:10px;
    `
  }}
`
export const IssueCreatorText = styled(Span)`
  ${(props: any) => {
    return `
    color:${props.theme.colors.blue9};
    text-transform: uppercase;
    font-size: 12px;
    line-height: 18px;
    margin-left: 10px;
    `
  }}
`
export const CommentText = styled(Span)`
  ${(props: any) => {
    return `
    color:${props.theme.colors.blue9};
    font-size: 14px;
    line-height: 18px;
    `
  }}
`
export const Breadcrumbs: any = styled(Flex)`
  display: inline-flex;
  width: auto;
`
export const BreadcrumbItem = styled(Button)`
  a {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
    color: inherit;
    display: block;
    text-decoration: none;
  }
  ${(props: any) => {
    return !props.disabled
      ? `color: ${props.theme.colors.blue6}`
      : `pointer-events:none`
  }}
`
export const TitleStyle = styled(P)`
  ${(props: any) => {
    return `
    color:${props.theme.colors.black};
    font-size: 14px;
    line-height: 18px;
    `
  }}
`
export const CreatedAtStyle = styled(P)`
  ${(props: any) => {
    return `
    color:${props.theme.colors.grey6};
    font-size: 12px;
    `
  }}
`
export const style: any = {
  downloadIcon: {
    color: 'rgb(0, 100, 145)',
    margin: '0 4px -2px',
    fontSize: 12
  }
}
const vehicleStyle = `
  // background: #fff;
  top: -25px;
  z-index: 1;
`
export const Ship: any = styled(MdDirectionsBoat)`
  color: rgb(30, 136, 229);
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const Truck: any = styled(MdLocalShipping)`
  color: rgb(30, 136, 229);
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const Plane: any = styled(IoIosAirplane)`
  color: rgb(30, 136, 229);
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const Rail: any = styled(MdTrain)`
  color: rgb(30, 136, 229);
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const MapDescription: any = styled(Flex)`
  position: absolute;
  min-width: 220px;
  top: 1vmax;
  left: 1vmax;
  background: #fff;
  z-index: 999;
  padding: 8px 15px;
  border-radius: 5px;
  box-shadow: 0 0 3px -1px ${(props: any) => props.theme.colors.grey3};
`
export const SpanModify = styled(Span)`
  text-transform: capitalize;
  width: auto;
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`

export const TripTabDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  height: 100%;
  @media only screen and (max-width: 768px) {
    grid-template-columns: unset;
    grid-template-rows: calc(100% - 180px) auto;
  }
`

export const GenericDetailsContainer: any = styled(Grid)<{
  showReference?: boolean
}>`
  background: #fff;
  grid-template-columns: ${({ showReference }) =>
    showReference
      ? `repeat(3, minmax(25%, 4fr))`
      : `repeat(3, minmax(33%, 1fr))`};
  grid-template-areas: ${({ showReference }) =>
    showReference
      ? `'route invoice reference vehicle'`
      : `'route invoice vehicle'`};
  gap: 1em;
  width: calc(100% - 1em);
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    ${({ showReference }) =>
      showReference
        ? {
            gridTemplateAreas: `'route route' 'reference reference' 'invoice vehicle'`
          }
        : {
            gridTemplateAreas: `'route route' 'invoice vehicle'`
          }}
  }
`

export const SidebarListingContainer: any = styled(Flex)<{
  containerStyle: any
}>`
  ${({ containerStyle }: any) => ({ containerStyle })}
  @media only screen and (max-width: 425px) {
    overflow-x: auto;
  }
`

export const PoiDetailContainer: any = styled(Flex)`
  flex-direction: column;
  width: 220px;
  padding: 30px 25px;
`
export const Details: any = styled(Flex)`
  padding: 0px 5px 5px;
  transform: translateX(-10px);
`
export const IconLine = styled.div`
  position: relative;
`
export const Icon = styled.div`
  z-index: 2;
  position: relative;
  display: inline-block;
`
export const Line: any = styled.div`
  width: 100%;
  position: absolute;
  border: 0px solid transparent;
  border-bottom: ${(props: any) =>
    `2px ${props.borderStyle} ${props.theme.colors[props.borderColor]}`};
  z-index: 1;
  &:before {
    content: '';
    display: ${(props: any) => (props.width > 0 ? 'block' : 'none')};
    position: absolute;
    background: ${(props: any) => props.theme.colors.blue7};
    height: 2px;
    width: ${(props: any) => props.width}%;
  }
  &:after {
    content: '';
    position: absolute;
    display: ${(props: any) =>
      props.width > 0 && props.width < 99 ? 'block' : 'none'};
    border: 3px solid ${(props: any) => props.theme.colors.blue7};
    background: #fff;
    height: 6px;
    width: 6px;
    top: -5px;
    left: ${(props: any) => props.width}%;
    border-radius: 6px;
  }
`
export const Stage: any = styled(Flex)`
  padding: 5px 0 0;
  flex-grow: 1;
  position: relative;
  min-width: 130px;
`

export const SideBarListing: any = styled(Span)`
  flex: 1;
  white-space: nowrap;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  padding: 12px 6px;
  letter-spacing: 0.4px;
  ${(props: any) => `
    color: ${props.theme.colors[props.isSelected ? 'grey7' : 'grey5']};
    border-bottom: 4px solid ${
      props.isSelected ? props.theme.colors.blue8 : 'transparent'
    };
    font-weight: ${props.isSelected ? 700 : 400};
  `}
  @media (min-width:1920px) {
    font-size: 14px;
    padding: 15px 8px;
  }
  ${layout}
`

export const OverflowWrapper = styled.div`
  height: calc(100vh - 146px);
  overflow: auto;
`
export const OverflowWrap = styled.div`
  height: calc(100vh - 146px);
  overflow: auto;
`
export const TripDetailsGroup: any = styled(Flex)`
  width: 100%;
  padding-left: 8px;
  box-sizing: border-box;
`
export const ExceptionStoppageGroup: any = styled(Flex)`
  width: 95%;
  margin: 15px -8px 0;
  padding: 15px;
  overflow: hidden;
  border-top: 1px solid ${(props: any) => props.theme.colors.gray5};
`
export const TripLabel = styled(Span)`
  width: 40%;
  padding: 7px 0;
`
export const TripLabelDetail = styled(Span)`
  width: 60%;
  padding: 7px 0;
`
export const HeaderFrame: any = styled(Flex)`
  width: 100%;
  line-height: 20px;
  font-family: Roboto;
  padding: 10px 15px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(225, 225, 225, 0.5);
  letter-spacing: 1px;
`

export const CopyText = styled.span`
  padding: 10px 20px;
  border: 1px solid #1890ff;
  border-radius: 4px;
  transition: 0.4s ease;
  width: 100%;
  display: block;
  overflow-x: auto;
  position: relative;
  overflow-y: hidden;
  box-sizing: border-box;
  text-overflow: inherit;
  white-space: nowrap;
  a {
    text-decoration: none;
    color: #1890ff;
  }
  .description {
    position: absolute;
    top: 60%;
    opacity: 0;
    font-size: 12px;
    width: 100%;
    justify-content: center;
  }
  &:hover {
    background: #e6f7ff;
    transition: 0.6s ease;
    .description {
      position: absolute;
      transition: 0.6s ease;
      top: 120%;
      opacity: 1;
      display: flex;
      color: #91d5ff;
    }
  }
`
export const GroupedButton: any = styled(Flex)`
  width: 100%;
  > * {
    margin: 0;
    border-radius: 0;
    &:nth-child(1) {
      border-radius: 3px 0 0 3px;
    }
    &:last-child {
      border-radius: 0 3px 3px 0;
    }
  }
`
export const DetailsContainer = styled.div`
  display: flex;
  padding: 0 4px;
  max-height: calc(100vh - 135px);
  box-sizing: border-box;
  overflow: hidden auto;
  background: #fff;
  @media only screen and (max-width: 425px) {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    height: unset;
  }
`

export const DetailsContainerInfo = styled.div`
  box-sizing: border-box;
  overflow: hidden auto;
  height: calc(100vh - 145px);
  @media (max-width: 1920px) {
    width: ${({ showMap }: { showMap: boolean }) => (showMap ? '29%' : '100%')};
  }
  @media (max-width: 1440px) {
    width: ${({ showMap }: { showMap: boolean }) => (showMap ? '36%' : '100%')};
  }
  @media (min-width: 1921px) {
    width: ${({ showMap }: { showMap: boolean }) => (showMap ? '25%' : '100%')};
  }
  @media only screen and (max-width: 425px) {
    flex: 1;
    flex-direction: column-reverse;
    width: 100%;
    height: unset;
  }
`

export const DisplayMapInfo = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  margin: 10px;
  @media (max-width: 1920px) {
    width: 70%;
  }
  @media (max-width: 1440px) {
    width: 63%;
  }
  @media (min-width: 1921px) {
    width: 74%;
  }
  @media only screen and (max-width: 425px) {
    flex: 1;
    width: 100%;
    height: 50vh;
  }
`

export const DetailsTimeline = styled.div`
  @media only screen and (max-width: 425px) {
    width: 100%;
    overflow-x: auto;
  }
`

export const TripTabs = styled.div`
  display: flex;
  margin-top: 6px;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.1);
  background: #ffffff;
  max-width: 100%;
  overflow-x: auto;
`
export const MoreActions = styled.div`
  height: 24px;
  width: 24px;
  cursor: pointer;
  background-color: ${(props: any) => props.theme.colors.gray4};
  margin: 4px 12px;
  border-radius: 12px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:active {
    box-shadow: 0 0 5px -1px ${props => props.theme.colors.gray6};
  }
  &:hover {
    box-shadow: 0 0 5px -1px ${props => props.theme.colors.gray6};
  }
`

export const ColorSpan = styled(Span)`
  color: ${(props: any) => props.theme.colors[props?.title || 'inherit']};
`
